import axios from '@axios'


export default {
    namespaced: true,
    state: {
        userInfo: (() => {
            const users = JSON.parse(localStorage.getItem('userData'))
            return users ? users : []
        })(),
    },
    getters: {

    },
    mutations: {
        SET_USER_INFO(state, data) {
            localStorage.setItem('userData', JSON.stringify(data))
            state.userInfo = data
        },
        UPDATE_USER_INFO(state, data) {
            const userInfo = JSON.parse(localStorage.getItem('userData'))
            for (const property of Object.keys(data)) {
                if (data[property] !== null) {
                    userInfo[property] = data[property]
                }
            }
            //console.log(userInfo)
            localStorage.setItem('userData', JSON.stringify(userInfo))
            state.userInfo = userInfo
        },
    },
    actions: {
        fetchUserInfo(ctx, {userId}) {
            return new Promise((resolve, reject) => {
                axios.get(`/admin/users/profile/${userId}`).then(response => {
                    //ctx.commit('UPDATE_USER_INFO', response.data.data, {root: true})
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
    }
}
